import { storeNps } from '@/api/passenger'

const storeNpsInfo = (context, npsInfo) => {
  return storeNps(npsInfo).then((response) => {
    return response
  })
}

export default {
  storeNpsInfo
}
